import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { formatDate, DatePipe } from '@angular/common';
import { LocalStorage } from 'ngx-store';
import { saveAs } from 'file-saver';

//Service
import { ExportService } from '../../../services/exporter.service';
import { ComplianceService } from './../../../services/compliance.service';

// MODEL
import { ThemeSetting,Url } from '../../../model/users.model';
import { FileExport } from '../../../model/exporter.model';

@Component({
  selector: 'app-massmanagement',
  templateUrl: './massmanagement.component.html',
  styleUrls: ['./massmanagement.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ ComplianceService, DatePipe ]
})
export class MassmanagementComponent implements OnInit {
  @LocalStorage() themeSettings: ThemeSetting;
  @LocalStorage() url: Url;

  showStartDateTime:  boolean = true;
  showCompliance:     boolean = true;
  showManifest:       boolean = true;
  showRunType:        boolean = true;
  showDriver:         boolean = true;
  showFleet:          boolean = true;
  showRoute:          boolean = true;
  showTruckAxle:      boolean = true;
  showTrailerAxle:    boolean = true;
  showSDPFile:        boolean = true;

  loadingIndicator:   boolean = true;
  showFilters:        boolean = false;
  massListCount:      number = 0;
  mass_list_length:   any;
  mass_list:          any[];
  selected = [];
  fullRows = [];
  routes = [];
  temp = [];
  data = [];

  //Handles the name, type and content of the to-be exported file
  public exp_excel: FileExport;
	public exp_pdf: FileExport;
  public folderPath: string;

  //Stores the filtered and formatted content of the file
	formatted_list : any;

  constructor(private http: HttpClient, private exporter: ExportService,  private complianceService: ComplianceService, private datepipe: DatePipe) { }

  ngOnInit(): void {
    this.getMassManagementList();

    //Declaration to handle the name, type and content of the file
    this.exp_excel = {title:'', list_data:'', type:''};
    this.exp_pdf = {title:'', list_data:'', type:''};

  }

  getMassManagementList(){
    this.folderPath = this.url.fileStorage;
    this.complianceService.getMassManagementList().subscribe(data=>{
      this.data = data['run'];
      this.routes = data['run_routes'];

      this.mass_list = this.data.map((info) => {
				let collated_drivers: string[] = [];
        let collated_equipments: string[] = [];

				for (let a of info.driver_name){
					collated_drivers.push(a.fullname);
				}

        for (let b of info.equipments){
          collated_equipments.push(b.rego);
        }

        let latest_date = this.datepipe.transform(info.start_datetime, 'yyyy-MM-dd');
				this.mass_list_length = Object.keys(collated_drivers).length;

				return { ...info, collated_drivers: collated_drivers.join(', '), collated_equipments: collated_equipments.join(', '), latest_date: latest_date};
			}); 
    
      //use for more filtering
      this.fullRows = this.mass_list;
      this.temp = this.mass_list;
      this.massListCount = Object.keys(this.mass_list).length;

      setTimeout(() => { this.loadingIndicator = false; }, 1500);
    })
  }

  public toggleFilters() {
    if (this.showFilters) 
      this.showFilters = false;
    else this.showFilters = true;
  }

  isFilterEmpty:    boolean = true;
  filterControlNo:  string = '';
  filterMDriver:    string = '';
  filterRego:       string = '';
  filterRoute:      string = '';
  filterDate:       Date;
  tempMassList = [];
  fullMassRows = [];

  updateFilter() {
    this.mass_list = this.fullRows; 
    this.temp = this.fullRows;    
    this.isFilterEmpty = false;

    if(this.filterDate) {
      this.temp = this.temp.filter(data => { 
        if (data.latest_date != null && data.latest_date !== ''){
          return (new Date(data.latest_date).toString() === new Date(this.filterDate).toString());
        }else{
          return data.latest_date;
        };
      });
    }
    
    if(this.filterControlNo) {
      this.temp = this.temp.filter(data => {
        if (data.control_no !== '' && data.control_no!=null){
           return (data.control_no.toLowerCase().indexOf(this.filterControlNo.toLowerCase()) !== -1 || !this.filterControlNo.toLowerCase());    
         }else{
           return (data.control_no);
         }
       });
    }
 
    if(this.filterMDriver) {
      this.temp = this.temp.filter(data => {
        if (data.collated_drivers != null && data.collated_drivers !== ''){
          return (data.collated_drivers.toLowerCase().indexOf(this.filterMDriver.toLowerCase()) !== -1 || !this.filterMDriver.toLowerCase());    
        }else{
          return data.collated_drivers;
        }
      });
    }

    if(this.filterRego) {
      this.temp = this.temp.filter(data => {
        if (data.collated_equipments != null && data.collated_equipments !== ''){
          return (data.collated_equipments.toLowerCase().indexOf(this.filterRego.toLowerCase()) !== -1 || !this.filterRego.toLowerCase());    
        }else{
          return data.collated_equipments;
        }
      });
    }

    if(this.filterRoute) {
      this.temp = this.temp.filter(data => {
        if (data.routes != null && data.routes !== ''){
           return (data.routes.toLowerCase().indexOf(this.filterRoute.toLowerCase()) !== -1 || !this.filterRoute.toLowerCase());   
         }else{
           return data.routes;
         }
       });
    }

    this.massListCount = Object.keys(this.temp).length;
    this.mass_list = this.temp;
  }

  public resetFilters() {
    this.filterDate = null;
    this.filterMDriver = '';
    this.filterRego = '';
    this.filterControlNo = '';
    this.filterRoute = '';
    this.massListCount = Object.keys(this.fullRows).length;
	  this.mass_list = this.fullRows;
    this.isFilterEmpty = true;
  }

  public formatDate(inDate: string) {
    let formatedDate: Date;
    if (inDate && !inDate.includes('0000')) {
      formatedDate = new Date(inDate.replace(/-/g, '/'));
      return formatedDate;
    } 
    else { 
      return null; 
    }
  }

  //Returns a date format in the file name
  public formattedDate(d = new Date) {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
  
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
  
    return `${day}/${month}/${year}`;
  }

  print2(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section2').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
      <title>Mass Management</title>
      <style>
      @page {
        size: A4;
      }

      table {
        border-collapse: collapse;
        border-spacing: 0;
        width: 100%;
        border: 1px solid #ddd !important;
    }

    th, td {
        text-align: left;
        padding: 16px;
    }


    tr:nth-child(even) {
        background-color: #f2f2f2 !important;
        box-shadow: inset 0 0 0 1000px #f2f2f2;
    }

    .fn {
      float: footnote;
    }

    thead {
      box-shadow: inset 0 0 0 1000px #f2f2f2;
    }
            
    </style>
    </head>
    <body onload="window.print();window.close()">${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }

  /*** Export Module ***/
  //Replaces an attribute name for reading comprehension
  renameKey( obj, oldKey, newKey ) {
    obj[newKey] = obj[oldKey];
    delete obj[oldKey];
  }

  //Formats readable header names in the given table
  massManagement_generateHeaders(mass_list): any{
    const arr = JSON.parse(mass_list);
    arr.forEach( obj => {
      this.renameKey( obj, 'control_no', 'Manifest No' );
      this.renameKey( obj, 'run_type', 'Run Type' );
      this.renameKey( obj, 'collated_drivers', 'Driver/s' );
      this.renameKey( obj, 'collated_equipments', 'Fleet/s' );
      this.renameKey( obj, 'routes', 'Route' );
      this.renameKey( obj, 'truck_axle', 'Truck Axles' );
      this.renameKey( obj, 'trailer_axle', 'Trailer Axles' );
      this.renameKey( obj, 'latest_date', 'Start Date' );
      this.renameKey( obj, 'is_compliant', 'Status' );
    });
    const updatedJson = JSON.stringify( arr );
    return updatedJson;
  }

  //Filters every column in the table list
  massManagement_generateColumnsWithFilter(mass_list){
      const arr = JSON.parse(JSON.stringify(mass_list));
      arr.forEach( obj => {
        //Format date
        obj['latest_date'] = formatDate(obj['latest_date'], 'dd MMM yyyy', 'en_US');

        //To display appropriate status
        if(obj['is_compliant'] == 1)
          obj['is_compliant'] = 'Compliant';
        else
          obj['is_compliant'] = 'Non-Compliant';

        //remove filtered columns
        if(!this.showStartDateTime){
          delete obj['latest_date'];
        };

        if(!this.showCompliance){
          delete obj['is_compliant'];
        };

        if(!this.showManifest){
          delete obj['control_no'];
        };

        if(!this.showRunType){
          delete obj['run_type'];
        };
        
        if(!this.showDriver){
          delete obj['collated_drivers'];
        };

        if(!this.showFleet){ 
          delete obj['collated_equipments'];
        };

        if(!this.showRoute){
          delete obj['routes'];
        };

        if(!this.showTruckAxle){
          delete obj['truck_axle'];
        };

        if(!this.showTrailerAxle){
          delete obj['trailer_axle'];
        };

        delete obj['run_type_id'];
        delete obj['run_id'];
        delete obj['driver_name'];
        delete obj['equipments'];
        delete obj['run_status_id'];
        delete obj['start_datetime'];
        delete obj['sdp'];
      });
      const updatedJson = JSON.stringify( arr );
      return updatedJson;                         
  }

  //Exports  table to CSV file
  massManagemen_exportToCSV(){
      if(this.mass_list.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.massManagement_generateColumnsWithFilter(this.mass_list);

          //generate json with format header
          this.formatted_list = this.massManagement_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let csv_file = '[TMS]Mass_Management_' + this.formattedDate(current_date);
          this.exporter.exportToCSV(this.formatted_list, csv_file, 'TMS Mass Management');
      }
  };

  //Exports Current Jobs table to PDF file
  massManagement_exportToPDF(){
    if(this.mass_list.length >0){
      let with_header_format, with_column_filter;

      //generate json with filtered column
      with_column_filter = this.massManagement_generateColumnsWithFilter(this.mass_list);

      //generate json with format header
      this.formatted_list = this.massManagement_generateHeaders(with_column_filter);

      //export to file
      let current_date = new Date();

      let pdf_file = '[TMS]Mass_Management_' + this.formattedDate(current_date);
      this.exp_pdf.title = 'MASS MANAGEMENT';
      this.exp_pdf.type = 'pdf';
      this.exp_pdf.list_data = this.formatted_list;
      this.exporter.exportToPDF(this.exp_pdf).subscribe(data=>{
        saveAs(data, pdf_file + '.' + this.exp_pdf.type);
      });
    }
  };

  //Exports table to MS Excel file
  massManagement_exportToExcel(){
      if(this.mass_list.length >0){
          let with_header_format, with_column_filter;
          
          //generate json with filtered column
          with_column_filter = this.massManagement_generateColumnsWithFilter(this.mass_list);

          //generate json with format header
          this.formatted_list = this.massManagement_generateHeaders(with_column_filter);

          //export to file
          let current_date = new Date();
          let excel_file = '[TMS]Mass_Management_' + this.formattedDate(current_date);
          this.exp_excel.title = 'MASS MANAGEMENT';
          this.exp_excel.type = 'xlsx';
          this.exp_excel.list_data = this.formatted_list;
          this.exporter.exportToExcel(this.exp_excel).subscribe(data=>{
              console.log(data);
              saveAs(data, excel_file)

          });
      }
  }; 

}
